import { RouteProp } from "@react-navigation/core"
import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { auth, IUserContext, logger, useAlert, userContext } from "capsule"
import React, { FC, useContext } from "react"
import { useTranslation } from "react-i18next"

import MfaSmsValidationForm from "../../components/MfaSmsValidationForm"
import currentDateMs from "../../features/hooks/useDateMock"
import { SMSValidationNS } from "../../features/i18n/constants"
import { AppUserData } from "../../features/models/UserData"
import { updateUserData } from "../../features/models/UserDataFunctions"
import { RootParamList } from "../../features/Navigation/types"
import { useNewPassword } from "../../features/Providers/MfaProvider"
import { IMainParamList } from "../MainScreen/MainNavigator"

type ValidationMfaPasswordModificationScreenRouteProp = RouteProp<
  RootParamList,
  "ValidationMfaPasswordModification"
>

interface IProps {
  route: ValidationMfaPasswordModificationScreenRouteProp
}
const ValidationMfaPasswordModificationScreen: FC<IProps> = ({ route }) => {
  const { verifId } = route.params
  const { newPassword } = useNewPassword()
  const { userDocRef } = useContext<IUserContext<AppUserData>>(userContext)
  const { t } = useTranslation(SMSValidationNS)
  const navigation = useNavigation<StackNavigationProp<IMainParamList, "Account">>()
  const { showSnack } = useAlert()
  const handleChangePassword = async () => {
    try {
      if (!newPassword) {
        showSnack({ message: t("unknown") })
        return
      }
      await auth().currentUser?.updatePassword(newPassword)
      await updateUserData(userDocRef, { passwordLastChangedAt: currentDateMs() })
      showSnack({ message: t("passwordChanged") })
      navigation.navigate("MainNavigator", { screen: "Home" })
    } catch (e) {
      logger("Confirmation code error: ", e)
      showSnack({ message: t("unknown") })
    }
  }

  return <MfaSmsValidationForm verifId={verifId} onSuccess={handleChangePassword} />
}
export default ValidationMfaPasswordModificationScreen
